import { Button, Text, Stack, Center, Box, Paper, Anchor } from "@mantine/core";
import {
  displayErrorMessage,
  displayInfoMessage,
} from "../shared/ErrorMessage";
import { Logo } from "../shared/components/Logo";
import { useUnsubscribeMutation } from "../slices/api/emailApi";
import { useEffect, useState } from "react";
import { Link } from "wouter";

interface Props {
  guestGuid: string;
}
const Unsubscribe = (props: Props) => {
  const [unsubscribe] = useUnsubscribeMutation();

  useEffect(() => {
    handleUnsubscribeVent();
  }, []);

  const [rsvpPageUrl, setRsvpPageUrl] = useState<string | null>(null);
  const [ventName, setVentName] = useState<string | null>(null);

  const handleUnsubscribeVent = async () => {
    try {
      const response = await unsubscribe({
        guestGuid: props.guestGuid,
        isUnsubscribedAll: false,
        isUnsubscribedHosts: false,
        isUnsubscribedVent: true,
      }).unwrap();
      setRsvpPageUrl(response.rsvpPageUrl);
      setVentName(response.ventName);
    } catch (error) {
      displayErrorMessage("Unsubscribe failed.");
      return;
    }
  };

  const handleUnsubscribeHosts = async () => {
    try {
      await unsubscribe({
        guestGuid: props.guestGuid,
        isUnsubscribedAll: false,
        isUnsubscribedHosts: true,
        isUnsubscribedVent: false,
      });
      displayInfoMessage(
        `You have been unsubscribed from all events hosted by the hosts of this event (${ventName}). To resubscribe you need to log in and change your user settings.`
      );
    } catch (error) {
      displayErrorMessage("Unsubscribe failed.");
      return;
    }
  };
  const handleUnsubscribeAll = async () => {
    try {
      await unsubscribe({
        guestGuid: props.guestGuid,
        isUnsubscribedAll: true,
        isUnsubscribedHosts: false,
        isUnsubscribedVent: false,
      });
      displayInfoMessage(
        "You have been unsubscribed from all events. To resubscribe you need to log in and change your usersettings."
      );
    } catch (error) {
      displayErrorMessage("Unsubscribe failed.");
      return;
    }
  };

  return (
    <Center style={{ height: "100vh" }}>
      <Stack align="center" justify="center" gap="sm">
        <Box w={100}>
          <Logo />
        </Box>
        <Text size="xl">
          <strong>You have been unsubscribed from this event</strong> (
          {ventName}).
        </Text>
        <Text size="lg">
          You will no longer receive emails from the event hosts. If you wish to
          resubscribe,{" "}
          <Anchor component={Link} href={rsvpPageUrl ?? ""} underline="hover">
            click here
          </Anchor>{" "}
          to go to your RSVP page and opt back in to host emails for this event.
        </Text>
        <Paper>
          Event hosts may send you invitations and reminders about their events.
          You may suppress those emails by unsubscribing from just this event
          (which you just did), from all events hosted by the hosts of this
          event, or from all events.
        </Paper>
        <Paper>
          If you unsubscribe using the buttons below and then change your mind,
          you will need to{" "}
          <Anchor component={Link} href={rsvpPageUrl ?? ""} underline="hover">
            log in
          </Anchor>{" "}
          and change your settings.
        </Paper>
        <Button style={{ width: "400px" }} onClick={handleUnsubscribeHosts}>
          Unsubscribe all events hosted by this event's hosts
        </Button>
        <Button style={{ width: "400px" }} onClick={handleUnsubscribeAll}>
          Unsubscribe from all events
        </Button>
      </Stack>
    </Center>
  );
};

export default Unsubscribe;
